import { render, staticRenderFns } from "./infakt-collections.vue?vue&type=template&id=129ada1c&scoped=true&"
import script from "./infakt-collections.vue?vue&type=script&lang=js&"
export * from "./infakt-collections.vue?vue&type=script&lang=js&"
import style0 from "./infakt-collections.vue?vue&type=style&index=0&id=129ada1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129ada1c",
  null
  
)

export default component.exports